import { memo, type FunctionComponent } from 'react';
// Material UI imports
import Box from '@mui/material/Box';
// Skillmore UI Components
import useDragAndDropItem, { type MoveItemFunction } from '@empathco/ui-components/src/hooks/useDragAndDropItem';
// local imports
import { Skill, SkillLevel } from '../models/skill';
import SkillChip from './SkillChip';

type SkillDraggableChipProps = {
  readonly skill: Skill;
  readonly level?: SkillLevel | null;
  readonly moveSkill?: MoveItemFunction;
  readonly onActivate?: (id: number, abbr: string) => void;
  readonly onDelete?: (id: number) => void;
  readonly disabled?: boolean;
};

const SkillDraggableChip: FunctionComponent<SkillDraggableChipProps> = ({
  skill,
  level,
  onActivate,
  onDelete,
  moveSkill,
  disabled = false
}) => {
  const { ref, isDragging } = useDragAndDropItem(skill.id, 'skill', moveSkill, disabled);
  return (
    <Box m={1}>
      <SkillChip
          ref={ref}
          skill={skill}
          level={level}
          draggable
          onActivate={onActivate}
          onDelete={onDelete}
          disabled={disabled}
          isDragging={isDragging}
      />
    </Box>
  );
};

export default memo(SkillDraggableChip);
